const config = {
  mapAppBarHeight: 64,
  basemaps: [
    { name: 'ArcGIS:Topographic', displayName: 'Topographic' },
    { name: 'ArcGIS:Streets', displayName: 'Streets' },
    { name: 'ArcGIS:Imagery', displayName: 'Satellite' },
  ],
  controlDrawerWidth: '375px',
  panelLabelWidth: 34,
  panelCollapseWidth: 350,
  contactEmail: 'Paul.Tarrant@tauranga.govt.nz',
  esriApiKey: process.env.REACT_APP_ESRI_API_KEY,
  googleMapsApiKey: process.env.REACT_APP_GOOGLE_API_KEY,
  selectLimit: process.env.REACT_APP_SELECT_LIMIT
    ? Number(process.env.REACT_APP_SELECT_LIMIT)
    : 12,
  auth0: {
    audience: process.env.REACT_APP_AUTH0_AUDIENCE,
    clientId: process.env.REACT_APP_AUTH0_CLIENT_ID,
    domain: process.env.REACT_APP_AUTH0_DOMAIN,
  },
  authEnabled:
    process.env.REACT_APP_AUTH_ENABLED &&
    process.env.REACT_APP_AUTH_ENABLED.toLowerCase() === 'true',
  namespace: process.env.REACT_APP_NAMESPACE,
  dataNavigatorUrl: process.env.REACT_APP_DATA_NAVIGATOR_URL,
  upload: {
    timeoutMs: (Number(process.env.REACT_APP_UPLOAD_TIMEOUT_MINUTES) || 60) * 60 * 1000,
    maxFileSizeGB: Number(process.env.REACT_APP_MAX_FILE_SIZE_GB) || 50,
  },
}

export default config

export const acceptMultiPartFiles = process.env.REACT_APP_ACCEPT_MULTI_PART_FILES === 'true'

// Generate accepted file types with optional multi-part extensions
const getAcceptedFileTypes = () => {
  let accepted_file_types = process.env.REACT_APP_ACCEPTED_FILE_TYPES || ''
  
  if (acceptMultiPartFiles) {
    // Generate array from .001 to .999
    const numberedExtensions = Array.from({ length: 999 }, (_, i) => 
      `.${String(i + 1).padStart(3, '0')}`
    ).join(',')
    accepted_file_types = accepted_file_types ? `${accepted_file_types},${numberedExtensions}` : numberedExtensions
  }
  
  return accepted_file_types
}

export const acceptedFileTypes = getAcceptedFileTypes()
export const portalUrl = process.env.REACT_APP_PORTAL_URL